import { useEffect, useState } from "react"
import EditSettings from "./EditSettings"
import { useDispatch, useSelector } from "react-redux"
import { Status } from "../../../components/Status"
import { css } from "@emotion/react"
import { Row, Col } from "react-bootstrap"
import { getCurrentUser } from "../../../data/authenticationSlice"
import { useNavigate } from "react-router-dom"

const componentStyle = css`
    padding-top: 100px;

    .page-container {
        margin-left: 24px;
        margin-right: 24px;
        background: #fff;
    }
`

const Profile = () => {
    const [showSetting, setShowSettings] = useState(false)
    const dispatch = useDispatch()
    const { user, fetchStatus } = useSelector((state) => state.authentication)

    useEffect(() => {
        dispatch(getCurrentUser())
    }, [])

    const hideSettings = () => {
        setShowSettings(false)
    }

    return (
        <div css={componentStyle}>
            <EditSettings
                show={showSetting}
                onHide={hideSettings}
            />

            <Row className="page-container">
                <Col>
                    <div className="d-flex justify-content-between align-items-center my-2">
                        <h2>Profile</h2>
                    </div>
                    <Status status={fetchStatus}>
                        <div className="mb-3">Click edit to update your information below :</div>
                        <div>
                            <strong>First Name: </strong> {user?.firstName}
                        </div>

                        <div>
                            <strong>Last Name: </strong> {user?.lastName}
                        </div>

                        <div>
                            <strong>Email: </strong> {user?.email}
                        </div>

                        <div>
                            <strong>Mobile Phone Number: </strong> {user?.phoneNumber}
                        </div>

                        <div>
                            <strong>Password: </strong> {"*".repeat(7)}
                        </div>
                        <button
                            className="btn btn-primary mt-3 btn-sm"
                            onClick={() => setShowSettings(true)}>
                            Edit
                        </button>
                    </Status>
                </Col>
            </Row>
        </div>
    )
}

export default Profile
